const AppConfig = {
  Name: 'Fast Tools',
  Email: 'info@fasttools.org',
};

export default AppConfig;
